import { FormHelperText, MenuItem, TextField, Box } from "@mui/material";

const CustomInputSelect = ({
  options = [],
  name,
  selectedValue,
  label,
  onChange,
  initialLabel = false,
  required = false,
  error = false,
  helperText = "",
  placeholder = "Select",
  size = "small",
  fullWidth = true,
  disabled = false,
  ...props
}) => {
  return (
    <Box sx={{ width: fullWidth ? "100%" : "auto" }}>
      <TextField
        id={name}
        select
        label={label}
        name={name}
        value={selectedValue ?? ""}
        onChange={onChange}
        required={required}
        error={error}
        disabled={disabled}
        variant="outlined"
        fullWidth={fullWidth}
        size={size}
        InputLabelProps={{
          shrink: true,
        }}
        SelectProps={{
          displayEmpty: true,
          renderValue: (value) => {
            if (!value) {
              return <span style={{ color: "#94a3b8", fontWeight: 400 }}>{placeholder}</span>;
            }
            return value;
          },
          sx: {
            "& .MuiSelect-select": {
              minHeight: "20px",
              display: "flex",
              alignItems: "center",
              py: 1,
              fontSize: "0.875rem",
              fontWeight: 500,
              color: selectedValue ? "#1e293b" : "#94a3b8",
            },
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: "8px",
            backgroundColor: disabled ? "#f1f5f9" : "#ffffff",
            transition: "all 0.2s ease",
            '& fieldset': {
              borderColor: error ? "#dc2626" : "#e2e8f0",
              borderWidth: error ? "2px" : "1.5px",
            },
            '&:hover fieldset': {
              borderColor: error ? "#dc2626" : "#94a3b8",
              borderWidth: error ? "2px" : "1.5px",
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? "#dc2626" : "#64748b",
              borderWidth: "2px",
              boxShadow: error 
                ? "0 0 0 3px rgba(220, 38, 38, 0.1)" 
                : "0 0 0 3px rgba(100, 116, 139, 0.1)",
            },
          },
          '& .MuiInputLabel-root': {
            fontSize: "0.85rem",
            color: "#64748b",
            fontWeight: 500,
            '&.Mui-focused': {
              color: "#475569",
            },
            '&.Mui-error': {
              color: "#dc2626",
            },
          },
          '& .MuiSelect-icon': {
            color: error ? "#dc2626" : "#94a3b8",
            transition: "transform 0.2s ease",
          },
          '& .MuiSelect-iconOpen': {
            transform: "rotate(180deg)",
          },
        }}
        {...props}
      >
        {initialLabel && (
          <MenuItem value="">
            <span style={{ color: "#94a3b8" }}>{placeholder || `Select ${label || name}`}</span>
          </MenuItem>
        )}
        
        {options?.map((item, index) => (
          <MenuItem 
            key={index} 
            value={item}
            sx={{
              fontSize: "0.875rem",
              padding: "10px 16px",
              fontWeight: 400,
              color: "#1e293b",
              transition: "all 0.15s ease",
              borderBottom: "1px solid #f1f5f9",
              '&:last-child': {
                borderBottom: "none",
              },
              '&:hover': {
                backgroundColor: "#f1f5f9",
              },
              '&.Mui-selected': {
                backgroundColor: "#e2e8f0",
                color: "#0f172a",
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: "#d1d5db",
                },
              },
            }}
          >
            {item}
          </MenuItem>
        ))}
      </TextField>
      
      {error && helperText && (
        <FormHelperText 
          error 
          sx={{ 
            mt: 0.5, 
            fontSize: "0.75rem",
            fontWeight: 500,
            color: "#dc2626",
            marginLeft: 0,
          }}
        >
          {helperText}
        </FormHelperText>
      )}
      {!error && helperText && (
        <FormHelperText 
          sx={{ 
            mt: 0.5, 
            fontSize: "0.7rem",
            color: "#94a3b8",
            marginLeft: 0,
          }}
        >
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CustomInputSelect;